<div id="parameter-search">
   <!--  <button mat-icon-button [matMenuTriggerFor]="searchMenu" matTooltip="{{'PARAMETERS.SEARCH' | translate}}"
        (menuOpened)="onMenuOpen()">
        <mat-icon class="secondary-text">search</mat-icon>
        
    </button> -->
    <div class="search-image-container" 
         [matMenuTriggerFor]="searchMenu" 
         matTooltip="{{'PARAMETERS.SEARCH' | translate}}"
         (menuOpened)="onMenuOpen()">
        <img src="assets/images/params-search/search_params.webp" 
             alt="Search Parameters" 
             class="search-image">
        <span class="search-label" fxHide fxShow.gt-sm>{{'PARAMETERS.PARAMETRE' | translate}}</span>
    </div>

    <mat-menu #searchMenu="matMenu" class="w-540">
        <mat-form-field class="px-16 w-100-p" (click)="$event.stopPropagation()" floatLabel="never">
            <input #searchInput matInput placeholder="{{'PARAMETERS.SEARCH_TEXT' | translate}}"
                (input)="search($event)">
        </mat-form-field>

        <mat-divider></mat-divider>

        <mat-nav-list *ngIf="searching" class="scrollable-list" fusePerfectScrollbar>
            <mat-list-item *ngFor="let navigationItem of filteredNavigationItems"
                (click)="navigateToItem(navigationItem)">
                <div class="w-100-p" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon mat-list-icon class="mr-8 secondary-text" *ngIf="navigationItem.icon">
                        {{ navigationItem.icon }}
                    </mat-icon>
                    <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" fxLayout="row"
                        fxLayoutAlign="center center" *ngIf="!navigationItem.icon">
                        {{ navigationItem.title.substr(0, 1).toUpperCase() }}
                    </span>
                    <p matLine fxFlex>{{ navigationItem.title }}</p>
                </div>
            </mat-list-item>

            <mat-list-item *ngIf="filteredNavigationItems.length === 0">
                <p>
                    <small>{{'PARAMETERS.NO_RESULTS' | translate}}</small>
                </p>
            </mat-list-item>
        </mat-nav-list>
    </mat-menu>
</div>